export default "__VITE_ASSET__PKhL87YB__"